import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import {
  getTemplate,
  confirmDeletingTemplate,
  cancelDeletingTemplate,
  deleteTemplate,
  getTemplateSuccess,
} from '../../../actions/template';
import { getFolders, setChoosedTemplateTags } from '../../../actions/folders';
import {
  setMenuTemplateGenerator,
  changeTemplateMenuDays,
  changeTemplateName,
  selectTemplateTagsFilters,
  setChosenTemplateEatings,
  setTemplateParametersCategories,
  changeTemplateDescription,
} from '../../../actions/templateGenerator';
import { transformMenuStructure } from '../../../actions/menu';
import AddTemplateButton from './AddTemplateButton';
import SingleTemplateItem from './SingleTemplateItem';
import DeleteConfirmPopup from '../../Common/DeleteConfirmPopup';
import { getTags } from '../../../actions/tags/getTags';
import FindTemplateContainer from '../../Common/FindTemplateContainer/FindTemplateContainer';
import {
  SET_SEARCH_TEMPLATE_NAME,
  SET_TEMPLATES_PAGINATION_PAGE,
  // eslint-disable-next-line import/named
} from '../../../constants/constants';
import {
  CATEGORY_INGREDIENTS,
  EATING_TAGS,
  TEMPLATE_PARAMETERS_TAG,
} from '../../../constants/appConstants';

class TemplatesList extends Component {
  componentDidMount() {
    const { getFolders, getTags, tags, getTemplateSuccess, setChoosedTemplateTags } = this.props;
    getTemplateSuccess('');
    getFolders();
    setChoosedTemplateTags([]);
    !tags.length && getTags();
  }

  handleCheckTemplate = (template) => {
    const { getTemplate } = this.props;
    getTemplate(template.complex_menu_id);
  };

  confirmDeleting = () => {
    const { template, confirmDeletingTemplate } = this.props;
    confirmDeletingTemplate(template.complex_menu_id, template.name);
  };

  handleDeleteTemplate = () => {
    const {
      deleteTemplate,
      template,
      getFolders,
      filteredTemplates,
      filterCategoryTemplates,
    } = this.props;
    deleteTemplate(template.complex_menu_id);

    if (filteredTemplates) {
      getFolders(filterCategoryTemplates);
    }
  };

  handleEditTemplate = () => {
    const {
      template,
      setMenuTemplateGenerator,
      changeTemplateMenuDays,
      changeTemplateName,
      selectTemplateTagsFilters,
      setChosenTemplateEatings,
      sameDaysCount,
      setTemplateParametersCategories,
      changeTemplateDescription,
    } = this.props;
    const transformedMenu = transformMenuStructure(template.menu, sameDaysCount);
    setMenuTemplateGenerator(transformedMenu);
    changeTemplateMenuDays(template.days);
    changeTemplateName(template.name);
    changeTemplateDescription(template.description);

    const categoryTagIds = [];
    const eatingTagIds = [];
    const paramTagIds = [];
    template.filters.forEach((tag) => {
      if (tag.category_id === CATEGORY_INGREDIENTS) categoryTagIds.push(tag.tag_id);
      if (tag.category_id === EATING_TAGS) eatingTagIds.push(tag.tag_id);
      if (tag.category_id === TEMPLATE_PARAMETERS_TAG) paramTagIds.push(tag.tag_id);
    });
    selectTemplateTagsFilters(categoryTagIds);
    setChosenTemplateEatings(eatingTagIds);
    setTemplateParametersCategories(paramTagIds);
  };

  render() {
    const {
      cancelDeletingTemplate,
      showConfirmPopup,
      template,
      getFolders,
      allTemplates,
      searchNameTemplate,
      isLoadTemplates,
      errMessTemplates,
      pageCount,
      setSearchTemplateName,
      setTemplatePaginationPage,
      tags,
    } = this.props;

    return (
      <Wrapper>
        <WrapFilterBlock>
          <FindTemplateContainer
            handleCheckTemplate={this.handleCheckTemplate}
            allTemplates={allTemplates}
            pageCount={pageCount}
            isLoadTemplates={isLoadTemplates}
            errMessTemplates={errMessTemplates}
            template={template}
            searchNameTemplate={searchNameTemplate}
            getFolders={getFolders}
            setSearchTemplateName={setSearchTemplateName}
            setTemplatePaginationPage={setTemplatePaginationPage}
            isRecommended={false}
            searchFieldWidth="100%"
            filterBlockWidth="100%"
            tags={tags}
          />
        </WrapFilterBlock>
        {template && (
          <SingleTemplateItem
            title={template.name}
            description={template.description}
            menu={template.menu}
            id={template.complex_menu_id}
            avgCalories={template.avg_calories}
            duration={template.days}
            onDelete={this.confirmDeleting}
            onEdit={this.handleEditTemplate}
          />
        )}
        {showConfirmPopup && (
          <DeleteConfirmPopup
            isOpen={showConfirmPopup}
            title={`шаблон ${template.name}`}
            onCancel={cancelDeletingTemplate}
            onDelete={() => this.handleDeleteTemplate()}
          />
        )}
        <AddTemplateButton />
      </Wrapper>
    );
  }
}

const mapStateToProps = (state) => {
  const { showConfirmPopup } = state.templateDelete;
  const { tags } = state.getTags;
  const {
    allTemplates,
    template,
    filterCategoryTemplates,
    searchNameTemplate,
    currentPage,
    isLoadTemplates,
    errMessTemplates,
  } = state.template;
  const { sameDaysCount } = state.menu;
  const { pageCount, warningWhenDeleting } = state.folders;

  return {
    showConfirmPopup,
    tags,
    allTemplates,
    template,
    filterCategoryTemplates,
    searchNameTemplate,
    currentPage,
    isLoadTemplates,
    errMessTemplates,
    pageCount,
    warningWhenDeleting,
    sameDaysCount,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    confirmDeletingTemplate: (id, name) => {
      dispatch(confirmDeletingTemplate(id, name));
    },
    cancelDeletingTemplate: () => {
      dispatch(cancelDeletingTemplate());
    },
    getFolders: (pageNumber, name, tags, userId, selectedComplexPeriod) => {
      dispatch(getFolders(pageNumber, name, tags, userId, selectedComplexPeriod));
    },

    getTemplate: (id) => {
      dispatch(getTemplate(id));
    },
    setSearchTemplateName: (name) => {
      dispatch({ type: SET_SEARCH_TEMPLATE_NAME, payload: { name } });
    },
    setTemplatePaginationPage: (numberPage) => {
      dispatch({ type: SET_TEMPLATES_PAGINATION_PAGE, payload: { numberPage } });
    },

    deleteTemplate: (id) => {
      dispatch(deleteTemplate(id));
    },
    getTags: () => {
      dispatch(getTags());
    },
    setMenuTemplateGenerator: (menu) => {
      dispatch(setMenuTemplateGenerator(menu));
    },
    changeTemplateMenuDays: (daysCount) => {
      dispatch(changeTemplateMenuDays(daysCount));
    },
    changeTemplateName: (templateName) => {
      dispatch(changeTemplateName(templateName));
    },
    changeTemplateDescription: (templateDescription) => {
      dispatch(changeTemplateDescription(templateDescription));
    },
    selectTemplateTagsFilters: (tags) => {
      dispatch(selectTemplateTagsFilters(tags));
    },
    setChosenTemplateEatings: (tagsIds) => {
      dispatch(setChosenTemplateEatings(tagsIds));
    },
    setTemplateParametersCategories: (templateParamTagsFilters) => {
      dispatch(setTemplateParametersCategories(templateParamTagsFilters));
    },
    getTemplateSuccess: (template) => {
      dispatch(getTemplateSuccess(template));
    },
    setChoosedTemplateTags: (tags) => {
      dispatch(setChoosedTemplateTags(tags));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TemplatesList);

const Wrapper = styled.div`
  width: 100%;
`;

const WrapFilterBlock = styled.div`
  width: 50%;
  margin: auto;
  @media (max-width: 992px) {
    width: 90%;
  }
`;



// WEBPACK FOOTER //
// ./src/Components/Templates/TemplatesList/TemplatesList.jsx